export const actions = {
  WATCHDOG_TRIGGER: 'PROGRESS_WATCHDOG_TRIGGER',
  SHOW_START: 'PROGRESS_SHOW_START',
  SHOW_END: 'PROGRESS_SHOW_END'
};
